import React from 'react';
import { Link } from 'gatsby';
import { Button, Column, Columns } from '@codeparva/ui-components-library';
import { weakKey } from '../../../../../../../utilities/weakKey';
import { JumbotronTypes } from '../../../jumbotronTypes';
import { useWindowDimensions } from '../../../../../../../utilities/Dimensions';

export const CTA = ({ buttonText, variant }: JumbotronTypes.ICTA) => {
  const { width } = useWindowDimensions();

  const renderButton = (buttonText: JumbotronTypes.TButtonText) => {
    return (
      <Link
        to={buttonText.link}
        state={{
          from: buttonText.label.toLowerCase().replace(/\s/g, ''),
          dataFrom: 'ctaButton',
        }}
        className={variant === 'multiLocationListOfCard' ? 'small' : 'medium'}
      >
        <Button
          size={`${variant === 'multiLocationListOfCard' ? 'small' : 'medium'}`}
          className={
            buttonText?.type === 'primary'
              ? 'PrimaryButton'
              : buttonText?.type === 'outlined'
              ? 'OutlinedButton'
              : 'CustomButton'
          }
          outlined={buttonText.type === 'outlined'}
        >
          <p className="subtitle1">{buttonText.label}</p>
        </Button>
      </Link>
    );
  };

  return (
    <Columns
      gap={
        variant === 'multiLocationListOfCard' && width >= 1024 && width <= 1124
          ? 1
          : ''
      }
      className="is-mobile is-align-items-center"
      data-cy="jumbotronButtonColumns"
    >
      {buttonText?.map((buttonText, index) => {
        return (
          buttonText.label &&
          ((variant === 'multiLocationListOfCard' && index <= 2) ||
            index <= 1) && (
            <Column
              key={weakKey(buttonText)}
              className={`CTA is-mobile ${
                variant === 'multiLocationListOfCard' ? 'mr-0' : 'mr-2'
              }`}
              narrow={true}
            >
              {renderButton(buttonText)}
            </Column>
          )
        );
      })}
    </Columns>
  );
};
